import KitchenIcon from "@mui/icons-material/Kitchen";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CastIcon from '@mui/icons-material/Cast';
import SupportIcon from '@mui/icons-material/Support';
import GroupIcon from '@mui/icons-material/Group';

import { routes } from "../routing/routes";

export const PUserNavTabs = [
 
  {
    id: "puserTransaction",
    label: "Dashboard",
    icon: <LocationCityIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.PUSER_TRANSACTION,
  },
  {
    id: "puserProfile",
    label: "Profile",
    icon: <AccountBoxIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.PUSER_PROFILE,
  },
  {
    id: "livestreaming",
    label: "Live Streaming",
    icon: <CastIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.LIVE_STREAMING,
  },
  {
    id: "help",
    label: "Help",
    icon: <SupportIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.HELP,
  },
   {
    id: "visitors",
    label: "Visitors",
    icon: <GroupIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.VISITORS,
  },
];
